<script lang="ts">
export default {
  name: 'Badge',
};
</script>

<script setup lang="ts">
const props = defineProps<{
  color?: string;
}>();
</script>

<template>
  <div class="badge badge-outline border
              h-fit w-fit bg-white
              text-nowrap text-center text-xs"
       :class="props.color? '' : 'border-primary text-primary'"
       :style="props.color ? `color: ${props.color}` : ''"
  >
    <slot></slot>
  </div>
</template>
